import { createAction } from '@reduxjs/toolkit';
export const SAVE_VOICEMAIL = 'SAVE_VOICEMAIL';
export const saveVoicemailAction = createAction(SAVE_VOICEMAIL);
